import { initializeLegacyBridge } from "./src/bootstrap";

initializeLegacyBridge();
